import { axiosApiInstance, headers } from './_httpHeaders';

// 1. 사용자 목록 조회
export const getUserList = (userInfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/system/selectUserList.do`,
    params: {
      cUsGrant: userInfo.cUsGrant,
      part: userInfo.part,
      cUsStatus: userInfo.cUsStatus,
      usGroupSeq: userInfo.usGroupSeq,
      searchText: userInfo.searchText,
      startDt: userInfo.startDt,
      endDt: userInfo.endDt,
      cContactType: userInfo.cContactType,
      pageStart: userInfo.pageStart,
      perPageNum: userInfo.perPageNum,
    },
  });

// 1. 사용자 목록 EXCEL 조회
export const getUserExcelList = (userInfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    responseType: 'arraybuffer',
    url: `${process.env.REACT_APP_API_URL}/user/system/selectUserExcelList.do`,
    params: {
      cUsGrant: userInfo.cUsGrant,
      part: userInfo.part,
      cUsStatus: userInfo.cUsStatus,
      usGroupSeq: userInfo.usGroupSeq,
      searchText: userInfo.searchText,
      startDt: userInfo.startDt,
      endDt: userInfo.endDt,
      cContactType: userInfo.cContactType,
      pageStart: userInfo.pageStart,
      perPageNum: userInfo.perPageNum,
    },
  });

// 2. 그룹 코드 조회
export const getGroupCodeList = () =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/system/selectGroupCodeList.do`,
    params: {},
  });

// 2.2. 부서명 조회
export const getDeptNmList = () =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/system/selectDeptNmList.do`,
    params: {},
  });

// 3. 사용자 승인
export const updateUserApproval = (userInfos) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/system/updateUserApproval.do`,
    data: userInfos,
  });

// 4. 사용자 해지
export const updateUserCancel = (userInfos) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/system/updateUserCancel.do`,
    data: userInfos,
  });

// 5. 사용자 상세 조회
export const getUserInfo = (userInfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/system/selectUserInfo.do`,
    params: {
      usId: userInfo,
    },
  });

// 6. 사용자 수정
export const updateUserInfo = (userInfo) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/system/updateUserInfo.do`,
    params: {
      C_US_GRANT: userInfo.C_US_GRANT,
      DEPT_NM: userInfo.DEPT_NM,
      US_GROUP_SEQ: userInfo.US_GROUP_SEQ,
      PRVC_RCMND_EMAIL: userInfo.PRVC_RCMND_EMAIL,
      C_US_STATUS: userInfo.C_US_STATUS,
      US_ID: userInfo.US_ID,
      US_CODE: userInfo.US_CODE,
      PRVC_GNRL_NM: userInfo.PRVC_GNRL_NM,
      PRVC_RCMND_TELNO: userInfo.prvcRcmndTelno,
    },
  });

// 7. 비밀번호 초기화
export const sendTempPwdAdmin = (userInfo) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/system/sendTempPwdAdmin.do`,
    data: {
      userId: userInfo.userId,
      coRprsBrno: userInfo.coRprsBrno,
      usCode: userInfo.usCode,
      telNo: userInfo.telNo,
      pwd: userInfo.pwd,
      status: userInfo.status,
    },
  });

// 1. 그룹 코드 초기데이터 조회
export const getGroupMngt = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/system/selectGroupMngt.do`,
    params: {
      usCode: reqParam,
    },
  });
// 1. 그룹관리 목록 조회
export const getGroupMngtList = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/system/selectGroupMngtList.do`,
    params: {
      usGroupNm: reqParam.usGroupNm,
      useYn: reqParam.useYn,
      pageStart: reqParam.pageStart,
      perPageNum: reqParam.perPageNum,
      usCode: reqParam.usCode,
    },
  });

// 1. 그룹관리 목록 EXCEL 조회
export const getGroupMngtExcelList = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    responseType: 'arraybuffer',
    url: `${process.env.REACT_APP_API_URL}/system/selectGroupMngtExcelList.do`,
    params: {
      usGroupNm: reqParam.usGroupNm,
      useYn: reqParam.useYn,
      pageStart: reqParam.pageStart,
      perPageNum: reqParam.perPageNum,
      usCode: reqParam.usCode,
    },
  });

// 그룹코드 삭제(다건)
export const deleteGroupMngtList = (reqParam) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/system/deleteGroupMngtList.do`,
    data: {
      deleteList: reqParam.deleteList,
      usCode: reqParam.usCode,
    },
  });

// 그룹코드 삭제
export const deleteGroupMngt = (reqParam) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/system/deleteGroupMngt.do`,
    data: {
      usGroupSeq: reqParam.usGroupSeq,
      usCode: reqParam.usCode,
    },
  });
// 그룹코드 상세조회
export const getGroupMngtDetail = (reqParam) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/system/selectGroupMngtDetail.do`,
    params: {
      usGroupSeq: reqParam.usGroupSeq,
    },
  });
// 그룹코드 등록
export const insertGroupMngt = (reqParam) =>
  axiosApiInstance({
    method: 'post',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/system/insertGroupMngt.do`,
    data: {
      usGroupNm: reqParam.usGroupNm,
      usGroupDc: reqParam.usGroupDc,
      usCode: reqParam.usCode,
      useYn: reqParam.useYn,
    },
  });
// 그룹코드 수정
export const updateGroupMngt = (reqParam) =>
  axiosApiInstance({
    method: 'put',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/system/updateGroupMngt.do`,
    data: {
      usGroupNm: reqParam.usGroupNm,
      usGroupDc: reqParam.usGroupDc,
      usCode: reqParam.usCode,
      useYn: reqParam.useYn,
      usGroupSeq: reqParam.usGroupSeq,
    },
  });
